const resource = '/shop-api/products'

export default (ctx, $axios) => ({
  byGuid (culture, guid) {
    return $axios.$get(`${resource}/${culture}/${guid}`);
  }
})
